module.exports = __webpack_public_path__ + "static/img/pass.88caf7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/pass.png
// module id = V4rl
// module chunks = 13